import axios from 'utils/axios';

const API_URL = 'question';

export interface GetQuestionsParams {
  page?: number;
  limit?: number;
  sortColumn?: string;
  sortOrder?: 'asc' | 'desc';
  questionType?: 'question' | 'task' | 'viva' | '';
  search?: string;
  assessmentSessionId?: string;
}

export const getQuestions = async (params?: GetQuestionsParams) => {
  return await axios.get(API_URL + '', { params });
};

export const addQuestion = async (data: any) => {
  return await axios.post(API_URL + '', data);
};

export const updateQuestion = async (data: any) => {
  return await axios.put(API_URL + '', data);
};

// Backend DELETE /question expects body { id: string }
export const deleteQuestion = async (id: string) => {
  return await axios.delete(API_URL + '/', { data: { id } });
};
